import { render, staticRenderFns } from "./MultiMchAddBankAccountModal.vue?vue&type=template&id=27bc051b&scoped=true"
import script from "./MultiMchAddBankAccountModal.vue?vue&type=script&lang=js"
export * from "./MultiMchAddBankAccountModal.vue?vue&type=script&lang=js"
import style0 from "./MultiMchAddBankAccountModal.vue?vue&type=style&index=0&id=27bc051b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bc051b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27bc051b')) {
      api.createRecord('27bc051b', component.options)
    } else {
      api.reload('27bc051b', component.options)
    }
    module.hot.accept("./MultiMchAddBankAccountModal.vue?vue&type=template&id=27bc051b&scoped=true", function () {
      api.rerender('27bc051b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/Modal/MultiMchAddBankAccountModal.vue"
export default component.exports